import React from 'react';

import { createUser, logout, clearRedirect} from "./../../actions/actions";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom'
import Button from  '@material-ui/core/Button'
import { Redirect } from  "react-router-dom";
import Header from './../Header';
import Footer from './../Footer';
import Toolbar from '@material-ui/core/Toolbar';
import { user_attr, role_names } from './../../helpers/trans';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import { withStyles} from '@material-ui/core/styles';
import { styles } from './../../helpers/classes';
import Paper  from '@material-ui/core/List';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import Chip from '@material-ui/core/Chip';

export const insp_roles = [ 'ROLE_INSPECTOR_MANAGER','ROLE_INSPECTOR_MAIN','ROLE_INSPECTOR_REPLIES', 'ROLE_INSPECTOR_APPEALS',  'ROLE_INSPECTOR_RECEIVE'];

export const org_roles = ['ROLE_BUILD_ORG', 'ROLE_BUILD_USER'];


export class ManageUser extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            type:'',
            title:'',
            redirect: null,
            user: {},
            auth: false,
            message:'',
            user_form: {
                roles: [],
                full_name:'',
                email:'',
                password:''
            }
        }
    }

    handleChange = event => {

        this.setState({ user_form: { ...this.state.user_form,roles: event.target.value }});
    };

    handleChangeMultiple = event => {
        const { options } = event.target;
        const value = [];
        for (let i = 0, l = options.length; i < l; i += 1) {
            if (options[i].selected) {
                value.push(options[i].value);
            }
        }
        this.setState({
            name: value,
        });
    };

    createUser = () => {
        let user = JSON.parse(localStorage.getItem('user'));
        this.props.createUser(user.token, this.state.user_form, this.props.match.params.type, this.props.match.params.id);
    }

    componentWillReceiveProps(nextProps) {
        if ('message' in nextProps) {
            this.setState({message:nextProps.message});
        }
    }

    componentWillMount() {
        let type = this.props.type;
        let title = this.props.title;
        if ('lovation' in this.props){type= this.props.location.state.type; title = this.props.location.state.title}
        let user = JSON.parse(localStorage.getItem('user'));
        if( user !== null || user.role.indexOf('ROLE_SUPER_ADMIN') > -1){
                this.setState({auth: true, user: user, type: type, title:title});
                this.props.clearRedirect();
            }
    }

    logout = () => {
        this.props.logout() ;
        this.setState({auth:false, redirect: null, user:{}});
    }

    updateInput = input => {
        let data = {[input.name]: input.value};
        let currentData = this.state.user_form;
        this.setState({user_form: {...currentData, ...data}});
    }

    render () {
        if (this.state.auth == false) {
            return (<Redirect to="/login"/>)
        }
        const {classes, user_form} = this.props;
        const roles = this.props.match.params.type === 'org' ? org_roles : insp_roles;
        return (<div>
            <Header link={{title: this.state.user.org, to:'/org-cabinet/'}}/>
            <Toolbar>
                <Button component={Link} to="/admin">Вернуться</Button>
                <Button onClick={this.logout}>Выйти</Button>
            </Toolbar>
            <Paper style={{paddingLeft:"4em",paddingRight:"4em"}}>
                <Paper style={{padding:"1em", marginTop:"1em", border:"1px #dedede solid"}}>
                    <Typography variant="h6">{`Создание пользователя для ${this.state.type} "${this.state.title}"`}</Typography>
                    <form>
                        <FormControl className={classes.formControl}>
                            <InputLabel htmlFor="select-multiple-checkbox">Привелегии</InputLabel>
                            <Select
                                multiple
                                value={this.state.user_form.roles}
                                onChange={this.handleChange}
                                input={<Input id="select-multiple-checkbox" />}
                                renderValue={selected => selected.map(item => ( role_names[item])).join(', ')}
                            >
                                {roles.map(name => (
                                    <MenuItem key={name} value={name}>
                                        <Checkbox checked={this.state.user_form.roles.indexOf(name) > -1} />
                                        <ListItemText primary={role_names[name]} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <TextField
                            className={classes.textField}
                            classes={{root: classes.rootFlex}}
                            required
                            onChange={e => this.updateInput(e.target)}
                            label="Email"
                            fullWidth
                            id="email"
                            name="email"
                            margin="dense"
                            value={this.state.user_form.email}
                            InputProps={{className: classes.input}}
                            InputLabelProps={{shrink: true, className: classes.label}}
                        />
                        <TextField
                            className={classes.textField}
                            classes={{root: classes.rootFlex}}
                            required
                            onChange={e => this.updateInput(e.target)}
                            label="ФИО"
                            fullWidth
                            id="full_name"
                            name="full_name"
                            margin="dense"
                            value={this.state.user_form.full_name}
                            InputProps={{className: classes.input }}
                            InputLabelProps={{shrink: true, className: classes.label}}
                        />
                        <TextField
                            className={classes.textField}
                            classes={{root: classes.rootFlex}}
                            required
                            onChange={e => this.updateInput(e.target)}
                            label="Пароль"
                            fullWidth
                            type="password"
                            id="password"
                            name="password"
                            margin="dense"
                            value={this.state.user_form.password}
                            InputProps={{className: classes.input}}
                            InputLabelProps={{shrink: true,className: classes.label}}
                        />
                    </form>
                    <Button color="#76b5b8" style={{display:"block", marginBottom:"2em", float:"none"}}
                            className={classes.button}
                            onClick={this.createUser}>
                        Обновить
                    </Button>
                    <Typography style={{color:"red"}}>{this.props.message}</Typography>
                </Paper>
            </Paper>
            <Footer />
        </div>);
    }
}


/* loadInspections, newNotification, signNotification, saveNotification, getNotification*/
function select(state, props) {
    const { user } = state;
    console.log('SELECT');
    console.log(user);
    return {
        message: (typeof user !== "undefined" && 'message' in user) ? user.message : '',
        user_form: (typeof user !== "undefined" && 'items' in user) ?  user.item : {},
        status: (typeof user !== "undefined" && 'status' in user) ? user.status : '',
    };
}

ManageUser.defaultProps = {
    user_form: {},
    message:''
}
function mapDispatch(dispatch) {
    return {
        clearRedirect: bindActionCreators(clearRedirect, dispatch),
        logout: bindActionCreators(logout, dispatch),
        createUser: bindActionCreators(createUser, dispatch),
    };
}

export const ManageUserWithStyles = withStyles(styles)(ManageUser);
export default connect(select, mapDispatch)(ManageUserWithStyles);



// WEBPACK FOOTER //
// ./assets/src/js/components/pages/CreateUser.jsx